import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client";
import LocalStorageService from "../services/localstorage.service";
import { PermissionsType } from "../types/permissions";
import { ProfileType } from "../types/profile";

const client = new HTTPClient();

export interface ProfilesResponse {
    profiles?: {
        data : Array<ProfileType>;
    };
    total?: number;
    error?: string;
}


export interface ProfileFilters {
    page: number;
    limit: number;
}

export interface ProfileForm {
    name: string;
    permissions: Array<PermissionsType>;
}

class ProfilesModel {
    static async find(profileId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/profiles/${profileId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ProfilesResponse
    }

    static async create(data: ProfileForm){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.POST,
            `${AUTH_URL}/profiles`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response = await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ProfilesResponse
    }

    static async update(profileId: number, data: ProfileForm){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.PUT,
            `${AUTH_URL}/profiles/${profileId}`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response = await client.put(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ProfilesResponse
    }

    static async getAll(filters: ProfileFilters){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/profiles?page=${filters.page}&limit=${filters.limit}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ProfilesResponse
    }
}

export default ProfilesModel;